export default "__VITE_ASSET__TyAQVd37__"